import { Record } from 'immutable';

const importStateRecord = Record({
  isBusy: 0
});

export class ImportState extends importStateRecord {
  isBusy: number;
}
